module.exports = __webpack_public_path__ + "static/img/create-bulk@2x.436821b5.svg";